<script>
import Vue from 'vue';
import { lory } from 'lory.js';
import SkySvg from 'sky-svg';
import SkySwiperItem from './sky-swiper-item';

// Register sub-component globally
Vue.component('sky-swiper-item', SkySwiperItem);
Vue.component('sky-svg', SkySvg);

const defaults = {
	slideSpeed: 500,
};

const preferences = {
	classNameFrame: 'sky-swiper-frame',
	classNameSlideContainer: 'sky-swiper-slides',
	classNamePrevCtrl: 'sky-swiper-prev',
	classNameNextCtrl: 'sky-swiper-next',
	ease: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
	infinite: 1,
};

export default {
	name: 'sky-swiper',
	data() {
		return {
			slides: [],
			currentSlide: 0,
			interval: null,
		};
	},
	props: {
		options: {
			type: Object,
		},
		autoplay: {
			type: Number,
			default: 0,
		},
	},
	methods: {
		addSlide(slide) {
			return this.slides.push(slide);
		},
		changeSlide(index) {
			this.lory.slideTo(index);
		},
	},
	mounted() {
		const options = Object.assign(defaults, preferences, this.options);

		this.$el.addEventListener('after.lory.slide', () => {
			this.$set(this, 'currentSlide', this.lory.returnIndex());
		});

		// Prevent default for touch devices
		// this prevents the user from scrolling on page Y
		this.$el.addEventListener('on.lory.touchstart', (e) => {
			e.detail.event.preventDefault();
		});

		setTimeout(() => {
			this.lory = lory(this.$el, options);
		});

		if (this.autoplay) {
			this.interval = setInterval(() => {
				this.lory.next();
			}, this.autoplay);
		}
	},
};
</script>

<style src="./sky-swiper.scss"></style>
<template src="./sky-swiper.html"></template>



// WEBPACK FOOTER //
// sky-swiper.vue?3bbcdc09